import { Navigate, useSearchParams } from 'react-router';
import { useSession } from '@/entities/session';
import { SETTINGS_SECTIONS, useOrgContext } from '../../entities/org';
import { BillingPanel } from './billing';
import { MembersPanel } from './members';
import { SettingsPage } from './settings-page';

export { OrgGeneralPage } from './general';
export { OrgWorkspacesPage } from './workspaces';

/**
 * `/o/:orgSlug/settings`: on to General. Links from before the sections were separate pages
 * (`?tab=members`) still land on their section.
 */
export function OrgSettingsIndex() {
  const { org } = useOrgContext();
  const [params] = useSearchParams();
  const tab = params.get('tab');
  const section = SETTINGS_SECTIONS.find((candidate) => candidate === tab) ?? 'general';
  return <Navigate to={`/o/${org.slug}/settings/${section}`} replace />;
}

/** `/o/:orgSlug/settings/members` (`members.manage`). */
export function OrgMembersPage() {
  const { org, can, activeWorkspaces, archivedWorkspaces } = useOrgContext();
  const { session } = useSession();
  return (
    <SettingsPage section="members">
      <MembersPanel
        org={org}
        currentUserId={session?.user.id ?? ''}
        callerIsOwner={can('org.transfer')}
        workspaces={[...activeWorkspaces, ...archivedWorkspaces]}
      />
    </SettingsPage>
  );
}

/** `/o/:orgSlug/settings/billing` (`billing.view`; changing needs `billing.manage`). */
export function OrgBillingPage() {
  const { org, can } = useOrgContext();
  return (
    <SettingsPage section="billing">
      <BillingPanel org={org} canManage={can('billing.manage')} />
    </SettingsPage>
  );
}
export { WorkspaceSettingsPage } from './workspace-settings';
